import { ScrollArea } from "@base-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"

import { OverlayHeader } from "shared/ui/overlay/OverlayHeader"
import { OverlayWrapper } from "shared/ui/overlay/OverlayWrapper"

import {
  ProjectAttachments,
  ProjectAttachmentsModel
} from "widgets/project-attachments/ProjectAttachments"

interface ProjectAttachmentsOverlayViewProps {
  attachmentsModel: ProjectAttachmentsModel
}

export const ProjectAttachmentsOverlayView = React.memo(
  ({ attachmentsModel }: ProjectAttachmentsOverlayViewProps) => {
    const { t } = useTranslation()
    return (
      <OverlayWrapper
        id="project-attachments-overlay"
        className="project-attachments-overlay"
        classNamePrefix="project-attachments-overlay"
        mobileFullscreen
      >
        <OverlayHeader.Container prefix="project-attachments-overlay">
          <OverlayHeader.CloseButton
            className="primary"
            label={t("General.Close")}
            data-testid="project-attachments-overlay__cancel"
          />
          <OverlayHeader.Title>
            {t("Project.Actions.Attachments")}
          </OverlayHeader.Title>
        </OverlayHeader.Container>
        <ScrollArea.Root className="project-attachments-overlay__content scroll-area scroll-area--vertical">
          <ScrollArea.Viewport className="scroll-area__viewport">
            <ScrollArea.Content className="scroll-area__content">
              <ProjectAttachments {...attachmentsModel} />
            </ScrollArea.Content>
          </ScrollArea.Viewport>
          <ScrollArea.Scrollbar
            orientation="vertical"
            className="scroll-area__scrollbar"
          >
            <ScrollArea.Thumb className="scroll-area__thumb" />
          </ScrollArea.Scrollbar>
        </ScrollArea.Root>
      </OverlayWrapper>
    )
  }
)
